import React from 'react';
import { Row, Col, message, InputNumber, Radio } from 'antd'
import { InputType } from './input-const';
import { Select } from 'antd';

const RadioGroup = Radio.Group;

//文件上传默认最大值10M
const defaultFileSize = 10;

/**
 * @author weishihuai
 * @date 2018/8/2
 * @time 14:26
 * @Description: 文件上传控件配置组件
 */
class SettingUpload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      feature: '',                        //原参数json字符串
      fileSize: defaultFileSize,
      featureParams: {
        size: defaultFileSize,          //上传文件默认限制最大为10M
        fileType: 'image',                //文件类型
        mode: 'file',
        numberLimit: 1,
        type: InputType.OLDUPLOAD,         //控件类型，必须有此属性，用于渲染时期判断控件类型
        required: false,                //是否必须(默认非必填)
        validationValueType: 'array'   //指定async-validator校验时值的类型(默认type是string,文件上传不能使用string,不然会报错form value is not string)
      }
    }
  }

  static defaultProps = {
    initFeature: ''
  };

  //在渲染前调用,可在此最后一次初始化组件状态
  componentWillMount() {
    //将输入控件配置参数设置到状态中
    if (this.props.initFeature) {
      try {
        let initFeature = JSON.parse(this.props.initFeature);
        if (initFeature.type == InputType.UPLOAD) {
          //定义文件上传的参数默认值
          let { required = false, fileType = 'image', size = defaultFileSize } = initFeature;
          const fp = { ...this.state.featureParams };
          fp.required = required;
          fp.fileType = fileType;
          fp.size = size;
          this.setState({
            feature: this.props.initFeature,
            featureParams: fp
          });
        }
      } catch (e) {
        console.log(e);
        message.error('解析控件配置参数出错！');
      }
    } else {
      try {
        let feature = JSON.stringify(this.state.featureParams);
        this.setState({
          feature: feature
        });
      } catch (e) {
        console.log(e);
        message.error('生成控件配置参数出错！');
      }
    }
  }

  //供父组件获取feature
  getFeature = () => {
    return this.state.feature;
  };

  //生成feature参数json字符串
  createFeature = (featureParams) => {
    try {
      let feature = JSON.stringify(featureParams);
      this.setState({
        feature: feature
      });
      this.props.onChange(feature);
    } catch (e) {
      message.error('生成控件配置参数出错！');
    }
  };

  //修改文件上传大小，同步更新控件参数
  handleSizeChange = (value) => {
    const fp = { ...this.state.featureParams };
    fp.size = value;
    this.setState({ fileSize: value, featureParams: fp });
    this.createFeature(fp);
  };

  //切换是否必填,同步更新控件参数
  handleRequiredRadioChange = (e) => {
    let required = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.required = required;
    this.setState({
      featureParams: fp
    });
    this.createFeature(fp);
  };

  //切换文件类型,同步更新控件参数
  handleFileTypeRadioChange = (e) => {
    let fileType = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.fileType = fileType;
    fp.mode = 'file'
    if (fileType === 'image') {
      fp.validationValueType = 'array'
    } else {
      fp.validationValueType = 'string'
    }
    this.setState({
      featureParams: fp
    });
    this.createFeature(fp);
  };
  handeModeChange = (value) => {
    const fp = { ...this.state.featureParams };
    fp.mode = value;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleNumberLimitChange = (value) => {
    const fp = { ...this.state.featureParams };
    fp.numberLimit = value;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  render() {
    const { fileSize, } = this.state;
    let { required, fileType, mode, numberLimit } = this.state.featureParams;
    return (
      <div id="input-setting-div">
        <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>文件上传配置信息</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>文件类型</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <RadioGroup onChange={this.handleFileTypeRadioChange} value={fileType}>
              <Radio value={'image'}>
                图片
                            </Radio>
              <Radio value={'file'}>
                文件
                            </Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>文件上传最大值</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <InputNumber size="small"
              min={0}
              formatter={value => `${value}M`}
              parser={value => value.replace('M', '')}
              value={fileSize}
              onChange={this.handleSizeChange}
            />
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>上传模式</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Select style={{ width: 120 }} onChange={this.handeModeChange} value={mode} >
              <Select.Option value='file'>file</Select.Option>
            </Select>
          </Col>
        </Row>
        <Row align='middle' type='flex' style={{ margin: '16px 0px 0px 0px' }}>
          <Col span={8}  >文件上传个数限制：</Col>
          <Col span={16}><InputNumber value={numberLimit} min={1} onChange={this.handleNumberLimitChange} /></Col>
        </Row>
        {/* <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>是否必填</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <RadioGroup onChange={this.handleRequiredRadioChange} value={required}>
              <Radio value={false}>
                非必填
              </Radio>
              <Radio value={true}>
                必填
               </Radio>
            </RadioGroup>
          </Col>
        </Row> */}
      </div>
    )
  }
}

export default SettingUpload;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-old-upload.js